"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeCookie = exports.ensureEncodedForJSCookie = void 0;
var ensureEncodedForJSCookie_1 = require("./ensureEncodedForJSCookie");
Object.defineProperty(exports, "ensureEncodedForJSCookie", { enumerable: true, get: function () { return ensureEncodedForJSCookie_1.ensureEncodedForJSCookie; } });
var serializeCookie_1 = require("./serializeCookie");
Object.defineProperty(exports, "serializeCookie", { enumerable: true, get: function () { return serializeCookie_1.serializeCookie; } });
